enum AnnotationActionTypes {
  Measure = 'Measure',
  Edit = 'Edit',
}

enum AnnotationTypes {
  Annotation = 'Annotation',
  Suggestion = 'Suggestion',
}

enum AnnotationModalTypes {
  Add = 'add',
  Edit = 'edit',
  EditSuggestion = 'editsuggestion',
  Suggestion = 'suggestion',
  MultiEdit = 'multiEdit',
}

enum AnnotationsStatuses {
  Confirmed = 'Confirmed',
  Rejected = 'Rejected',
}

enum DefectActions {
  None = 'none',
  EvaluationNeeded = 'eval_needed',
  Unknown = 'unknown',
}

enum DefectTypes {
  composite = 'Composite',
  paint_defect = 'Paint Defect',
  minor_paint_defect = 'Minor Paint Defect',
  missing_fasteners = 'Missing Fasteners',
  scratch = 'Scratch',
  gouge = 'Gouge / Nick',
  corrosion = 'Corrosion',
  seal_damage = 'Seal Damage',
  fluid_leak = 'Fluid Leak',
  hardware = 'Hardware',
  seal = 'Seal',
  sealant_damage = 'Sealant Damage',
  composite_damage = 'Composite Damage',
  missing_damaged_part = 'Missing/Damaged Part',
  cracks = 'Cracks',
  dent = 'Dent',
  punctures_holes = 'Punctures and Holes',
  lightning_strike = 'Lightning Strike',
  bird_strike = 'Bird Strike',
  other = 'Other',
}

enum DefectCategories {
  paint_defect = 'Paint Defect Anomaly',
  seal = 'Seal Anomaly',
  hardware = 'Hardware Anomaly',
  other = 'Other Anomaly',
  composite = 'Composite Anomaly',
}

enum DefectStatusValueTypes {
  RequiresInspection = 'requires_inspection',
  GroundingCondition = 'grounding_condition',
  NonGroundingCondition = 'non_grounding_condition',
  ForAwareness = 'for_awareness',
}

enum DefectStatusTypes {
  requires_inspection = 'Requires Inspection',
  grounding_condition = 'Grounding Condition',
  non_grounding_condition = 'Non Grounding Condition',
  for_awareness = 'For Awareness',
}

enum DefectStatusIndicatorTypes {
  requires_inspection = '( - )',
  grounding_condition = '( X )',
  non_grounding_condition = '( / )',
  for_awareness = '(   )',
}

enum MeasurementStatus {
  Pending = 'pending',
  Success = 'success',
  Error = 'error',
}

enum AnnotatorModes {
  Create = 'create',
  Select = 'select',
}

enum MarkerTypes {
  Polygon = 'PolygonMarker',
  Rectangle = 'RectangleMarker',
  Measurement = 'MeasurementMarker',
  Selection = 'SelectionMarker',
}

enum ViewModes {
  Annotator = 'Annotator',
  Visualizer = 'Visualizer',
  History = 'History',
}

enum AnnotationPopoverPositions {
  Top = 'top',
  Left = 'left',
  Bottom = 'bottom',
  Right = 'right',
}

export {
  AnnotationActionTypes,
  AnnotationTypes,
  AnnotationsStatuses,
  AnnotationModalTypes,
  DefectActions,
  DefectCategories,
  DefectTypes,
  DefectStatusValueTypes,
  DefectStatusTypes,
  DefectStatusIndicatorTypes,
  AnnotatorModes,
  MarkerTypes,
  ViewModes,
  AnnotationPopoverPositions,
  MeasurementStatus,
}
